import { render, staticRenderFns } from "./EditMenuModal.vue?vue&type=template&id=54cabfdf"
import script from "./EditMenuModal.vue?vue&type=script&lang=ts"
export * from "./EditMenuModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports